import React, { Component } from 'react'
import { connect } from 'react-redux'
import chicken from './svg/001-chicken.svg'
import meat from './svg/002-meat.svg'
import fish from './svg/003-fish.svg'
import turkey from './svg/006-turkey.svg'
import pig from './svg/004-pig.svg'
import nomeat from './svg/005-meat-1.svg'
import seafood from './svg/seafood.svg'
import sheep from './svg/sheep.svg'
import './meats.css'
class Meats extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="section-text col-md-12 col-lg-6">Carnes</div>
          <div className="options col-sm-12 col-md-12 col-lg-6">
            <p className="textHelp">
              Selecciona tus opciones deseadas y haz click en siguiente
            </p>
            <div className="row">
              <div
                onClick={() => this.props.selectMeat(0)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[0] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={chicken} alt="Pollo" />
                </div>
                <label>Pollo</label>
              </div>
              <div
                onClick={() => this.props.selectMeat(1)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[1] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={meat} alt="Ternera" />
                </div>
                <label>Ternera</label>
              </div>
              <div
                onClick={() => this.props.selectMeat(2)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[2] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={fish} alt="Pescado" />
                </div>
                <label>Pescado</label>
              </div>
              <div
                onClick={() => this.props.selectMeat(3)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[3] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={turkey} alt="Pavo" />
                </div>
                <label>Pavo</label>
              </div>
              <div
                onClick={() => this.props.selectMeat(4)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[4] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={pig} alt="Cerdo" />
                </div>
                <label>Cerdo</label>
              </div>
              <div
                onClick={() => this.props.selectMeat(5)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[5] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={seafood} alt="Sin carnes" />
                </div>
                <label>Mariscos</label>
              </div>
              <div
                onClick={() => this.props.selectMeat(6)}
                className={
                  'elementicon col-4 ' +
                  (this.props.carnes[6] ? 'option-active' : null)
                }
              >
                <div style={{ display: 'contents' }}>
                  <img src={sheep} alt="Sin carnes" />
                </div>
                <label>Cordero</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  carnes: state.carnes,
})
const mapDispatchToProps = (dispatch) => ({
  selectMeat(optionmeat) {
    dispatch({
      type: 'SELECT_MEAT',
      optionmeat: optionmeat,
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(Meats)
